import store from '../store';
import * as types from '../actions/location-actions';

class LocationApi {
	/**
	 * Changes Location
	 */
	static setLocation(location) {
		if (!/\./g.test(location.pathname))
			return store.dispatch(LocationApi.setLocationSuccess(location));
	}

	/**
	 * Changes Location
	 * @param location
	 * @returns {{type, location: *}}
	 */
	static setLocationSuccess(location) {
		return {
			type: types.SET_LOCATION_SUCCESS,
			location
		};
	}
}

export default LocationApi;






// WEBPACK FOOTER //
// ./src/api/location-api.js